import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const deleteCharge = async ({
    token,
    charge_id
}) => {

    try {
        const res = await axiosCreate.delete('/charge/status',{
            data: {
                charge_id
            },
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}